var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7285_8574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0836 9.33357C14.2535 9.33376 14.4169 9.39882 14.5405 9.51547C14.664 9.63211 14.7384 9.79154 14.7484 9.96116C14.7583 10.1308 14.7031 10.2978 14.5941 10.4281C14.485 10.5584 14.3303 10.6422 14.1616 10.6622L14.0836 10.6669H5.02624L6.5549 12.1956C6.67447 12.3155 6.74389 12.4765 6.74906 12.6458C6.75423 12.8151 6.69476 12.98 6.58274 13.1071C6.47072 13.2341 6.31454 13.3138 6.14592 13.3298C5.97731 13.3459 5.8089 13.2972 5.6749 13.1936L5.61224 13.1382L3.0589 10.5849C2.61557 10.1422 2.89957 9.39623 3.5009 9.33757L3.57757 9.33357H14.0836ZM10.9456 2.86223C11.0604 2.74745 11.2131 2.67849 11.3751 2.66831C11.5371 2.65812 11.6973 2.7074 11.8256 2.8069L11.8882 2.86223L14.4416 5.41557C14.8849 5.85823 14.6009 6.60423 13.9996 6.6629L13.9229 6.6669H3.4169C3.24698 6.66671 3.08355 6.60165 2.95999 6.485C2.83644 6.36835 2.76208 6.20893 2.75212 6.0393C2.74217 5.86968 2.79735 5.70265 2.90641 5.57234C3.01547 5.44204 3.17017 5.3583 3.3389 5.33823L3.4169 5.33357H12.4742L10.9456 3.8049C10.8206 3.67988 10.7504 3.51034 10.7504 3.33357C10.7504 3.15679 10.8206 2.98725 10.9456 2.86223Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7285_8574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.781e84b4468de2631a55bbfacf785dfd.svg";
export { ForwardRef as ReactComponent };